import script from "./sf-inpage-list-item-subtitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-inpage-list-item-subtitle.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__